<template>
  <input :value="optionValueForValue"
         type="text"
         autocomplete="off"
         @click="showSuggestions"
         @focus="showSuggestions">
</template>

<script>
/* eslint-disable no-undef */
import 'bower/devbridge-autocomplete/dist/jquery.autocomplete'

export default {
  props: {
    value: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      required: true
    }
  },
  data () {
    const optionValue = this.optionValueForValue
    return {
      autoCompleteValue: optionValue,
      autoComplete: null
    }
  },
  computed: {
    optionValueForValue: function () {
      if (this.value) {
        const selectedOption = this.options.find(option => option.data === this.value)
        if (selectedOption) {
          return selectedOption.value
        }
      }
      return ''
    }
  },
  watch: {
    options: function (value) {
      this.autoComplete.setOptions({ lookup: value })
    }
  },
  mounted: function () {
    this.autoComplete = jQuery(this.$el).devbridgeAutocomplete({
      lookup: this.options,
      minChars: 1,
      onSelect: (suggestion) => this.updateValue(suggestion),
      onInvalidateSelection: () => this.clearValue()
    }).devbridgeAutocomplete()
  },
  beforeDestroy: function () {
    this.autoComplete.dispose()
  },
  methods: {
    updateValue: function (suggestion) {
      if (suggestion.data === this.value) {
        return
      }
      this.$emit('input', suggestion.data)
    },
    clearValue: function () {
      this.$emit('input', '')
    },
    showSuggestions: function () {
      if (!this.autoCompleteValue) this.autoComplete.getSuggestions('')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/forms/components/AutoComplete.vue